$(document).ready(function(){
  // $("#search-block").click(function(){
  //   $(".header-bottom .nav-search-mobile").toggle();
  // });
  
  if ($.cookie('headerTop') == 'closed') {
    $('.header-top').remove();
  }
  
  $('.header-top a.close').bind('click',function(){
    $('.header-top').remove();
    $.cookie('headerTop', 'closed', {expires:1, path:'/'});
  });
  
  // translator.updateLangSwitcher();
  // $('#lang-switcher').selectize();
});
